import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filesize'
})
export class FilesizePipe implements PipeTransform {

    transform(value: any, args?: any): any {
        value = parseInt(value, 10);
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (value === 0) {
            return 'n/a';
        }
        const i = Math.floor(Math.log(value) / Math.log(1024));
        if (i === 0) {
            return value + ' ' + sizes[i];
        }
        return String((value / Math.pow(1024, i)).toFixed(1)) + ' ' + sizes[i];

    }

}



// WEBPACK FOOTER //
// ./src/app/shared/filesize.pipe.ts